import {
    AfterContentInit,
    Component,
    Inject,
    Input,
    OnDestroy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { RowSelectionManagerDirective } from "./manager.directive";
import { GroupReducerFactory } from "./reducer";
import { LIST_CONTROLS_STATE_PROP } from "./state-props";

@Component({
    selector: "row-selection",
    template: "<ng-content></ng-content>",
    providers: [RowSelectionManagerDirective],
})
export class RowSelectionComponent implements OnDestroy, AfterContentInit {
    @Input() public stateProp: string;
    @Input() public initialState = { ids: {}, allSelected: false };
    public state$: Subscription;

    constructor(
        private ngRedux: ImmutableRedux<any>,
        public manager: RowSelectionManagerDirective,
        @Inject(LIST_CONTROLS_STATE_PROP) public rootProp,
    ) {
        manager.rootProp = this.rootProp;
    }

    public ngAfterContentInit(): void {
        this.ngRedux.registerComponent(
            GroupReducerFactory,
            this.rootProp,
            this.stateProp,
            this.initialState,
        );
    }

    public ngOnDestroy() {
        this.ngRedux.unregisterComponent(this.rootProp, this.stateProp);
    }
}
